import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { WidgetTypes } from 'interfaces';
import SubDeterminantBadge from './SubDeterminantBadge.CB';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';

export default defineComponent({
	props: {
		studyId: Number,
		widgetType: String,
		widgetLocation: String,
		emptyText: String,
		determinantType: Number,
	},
	setup: (props) => {
		const studyId = props.studyId as number;
		const widgetType = props.widgetType as WidgetTypes;
		const widgetLocation = props.widgetLocation as string;
		const emptyText = props.emptyText as string;
		const determinantType = props.determinantType as
			| ScoreDeterminantType
			| undefined;

		const codeBehind = new SubDeterminantBadge(
			studyId,
			widgetType,
			widgetLocation,
			emptyText,
			determinantType,
		);

		return setupComponent(codeBehind);
	},
});
